/**
 * NewsListPage
 */

import React from "react";
import { NewsListPageModel } from "types/pages";

import Breadcrumb from "components/Breadcrumb";
import Image from "components/Image";

/** News list page (listing NewsPages). */
const NewsListPage: React.FC<NewsListPageModel> = ({
    heading,
    subHeading,
    pages,
    preamble,
}) => {
    return (
        <div>
            <div className="mx-auto main-w-container px-8 xl:px-0">
                <Breadcrumb className="mt-1 mb-6" />
                <h1 className="font-bold">{heading}</h1>
                   {preamble && (
                            <p className="font-semibold">{preamble}</p>
                        )}
                <div className="w-full flex flex-wrap py-4 md:px-0">                   
                        <h2 className="font-bold mb-2 md:mb-4">{subHeading}</h2>                     
                    
                    {pages.map((page, i) => (
                        <article
                            key={i}
                            aria-labelledby={`heading-${page.id}`}
                            className="w-full text-black pt-2 pb-4 md:py-5 border-t-2 last:border-b-2 border-grey-light"
                        >
                            <div className="flex flex-col md:flex-row md:items-start md:gap-8">
                                <div
                                    className={
                                        page.puffImage
                                            ? "w-full md:w-grid-10/12"
                                            : "w-full"
                                    }
                                >
                                    <h3
                                        id={`heading-${page.id}`}
                                        className="font-bold leading-6 my-2 lg:my-4"
                                    >
                                        <a
                                            href={page.link?.url}
                                            className="text-black hover:underline"
                                        >
                                            {page.heading}
                                        </a>
                                    </h3>
                                    <p
                                        className={
                                            "text-p relative before:content-[''] before:inline-block before:w-[0.7em] before:h-[0.7em] before:rounded-full before:bg-red-500 before:mr-2 align-middle"
                                        }
                                    >
                                        {page.date}
                                    </p>
                                    {page.body && (
                                        <p className="text-p">{page.body}</p>
                                    )}
                                </div>
                                {page.puffImage && (
                                    <div className="w-full md:w-grid-2/12 mt-4 md:mt-0 flex justify-center">
                                        <Image
                                            src={page.puffImage?.src}
                                            alt={page.puffImage?.alt}
                                            className="w-full h-auto md:w-[140px] md:h-[140px] object-cover object-center"
                                        />
                                    </div>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewsListPage;
